import * as Styled from "./styled";
import { Spinner } from "@/components/shared-ui/LoadingScreen/styled";
import ErrorScreen from "@/components/shared-ui/ErrorScreen";
import Card from "@/components/shared-ui/Card";
import Button from "@/components/shared-ui/Button";
import useOnrampProjects from "@/hooks/useOnrampProjects";
import calculateDaysProgress from "./calculateDaysProgress";

type OnboardingCardProps = {
  canAccessOnramp: boolean;
};

const OnboardingCard = ({ canAccessOnramp }: OnboardingCardProps) => {
  const { data: projects, isPending, isError } =
    useOnrampProjects(canAccessOnramp);

  if (!canAccessOnramp) {
    return null;
  }

  if (isPending) {
    return (
      <Card gridColumn="1 / -1">
        <Spinner />
      </Card>
    );
  }

  if (isError) {
    return (
      <Card gridColumn="1 / -1" data-testid="onboardingCard">
        <ErrorScreen withoutPage />
      </Card>
    );
  }

  return (
    <Card gridColumn="1 / -1" data-testid="onboardingCard">
      <Styled.CardHeading>Onboarding progress</Styled.CardHeading>
      {projects.map((project) => {
        const daysProgress = calculateDaysProgress(
          project.start_date,
          project.end_date,
        );

        return (
          <Styled.Wrapper key={project.project_name}>
            <Styled.ProjectName>{project.project_name}</Styled.ProjectName>
            <Styled.ProgressBox>
              <span>
                <strong>{project.percent_complete}%</strong> complete
              </span>
              <Styled.ProgressBar progress={Number(project.percent_complete)} />
            </Styled.ProgressBox>
            <Styled.ProgressBox>
              <span>
                <strong>
                  {Number(project.days_remaining) > 0
                    ? project.days_remaining
                    : 0}
                </strong>{" "}
                days remaining
              </span>
              <Styled.ProgressBar progress={daysProgress} />
            </Styled.ProgressBox>
            <Styled.LinkWrapper>
              <Button
                label="Track your project"
                variant="secondary"
                type="button"
                onClick={() =>
                  window.open(
                    project.project_link,
                    "_blank",
                    "noopener,noreferrer",
                  )
                }
              />
            </Styled.LinkWrapper>
          </Styled.Wrapper>
        );
      })}
    </Card>
  );
};

export default OnboardingCard;
